module.exports = __webpack_public_path__ + "asset/image-ic_category_23-b663568019c9fd72.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/ic_category_23.svg
// module id = it8l
// module chunks = 0